// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1SGbw","title":"styles_title__g6ZxI"};